export const MEDIA_MASK_NONE = 'none';
export const MEDIA_MASK_ORIGINAL = 'original';
export const MEDIA_MASK_1 = 'mask-v1';
export const MEDIA_MASK_2 = 'mask-v2';
export const MEDIA_MASK_3 = 'mask-v3';
export const MEDIA_MASK_4 = 'mask-v4';
export const MEDIA_MASK_5 = 'mask-v5';
export const MEDIA_MASK_6 = 'mask-v6';

export type MaskVariant =
	| typeof MEDIA_MASK_NONE
	| typeof MEDIA_MASK_ORIGINAL
	| typeof MEDIA_MASK_1
	| typeof MEDIA_MASK_2
	| typeof MEDIA_MASK_3
	| typeof MEDIA_MASK_4
	| typeof MEDIA_MASK_5
	| typeof MEDIA_MASK_6;

export const maskToAspectRatio = (maskVariant?: MaskVariant) => {
	if (
		!maskVariant ||
		maskVariant === MEDIA_MASK_NONE ||
		maskVariant === MEDIA_MASK_ORIGINAL
	) {
		return {width: 200, height: 200};
	}

	switch (maskVariant) {
		case MEDIA_MASK_1:
		case MEDIA_MASK_2:
		case MEDIA_MASK_3:
			return {width: 1440, height: 810};
		case MEDIA_MASK_4:
			return {width: 625, height: 700};
		case MEDIA_MASK_5:
			return {width: 708, height: 836};
		case MEDIA_MASK_6:
			return {width: 708, height: 867};
	}
};
